<template>
  <main id="main" class="ms-sm-auto">
    <div class="container">

      <div class="card" v-if="skills.length > 0">
          <div class="card-header">
              <div class="card-title">{{$t("p_teacher_rate")}}</div>
          </div>
          <div class="card-body">

              <div class="card-body-skill-assessment" style="padding: 0 130px;">
                  <div class="row">
                      <div class="col-md-6 mb-32 d-flex" v-for="(skill, index) in skills" v-bind:key="index">
                          <template v-for="(s, i) in skill.max">
                              <div class="reactange mr-4" v-if="i >= skill.value" v-bind:key="i"></div>
                              <div class="reactange reactange-1 mr-4" v-else v-bind:key="i"></div>
                          </template>
                          <div class="text-capitalize" style="margin-left: 8px">{{skill.skill_code}}</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="card card-feedback">
          <div class="card-header">
              <div class="card-title">{{$t('p_teacher_feedback')}}</div>
              <div class="card-tools">
                  <div class="show-history opened" v-if="show_all_feedbacks" @click="updateShowAllFeedback(false)"><img src="/themes/web/assets/images/Chevron_Right_Duo_2.svg" alt=""> {{$t('p_history')}}</div>
                  <div class="show-history" @click="updateShowAllFeedback(true)" v-else><img src="/themes/web/assets/images/Chevron_Right_Duo.svg" alt="">{{$t('history')}}</div>
              </div>
          </div>
          <div class="card-body">
              <div id="feedback">
                  <div class="feedback-body">
                      <div class="nano" style="height:400px">
                          <div class="nano-content">
                              <div class="feedback-list" style="padding:0 0 100px 0 !important">

                                <div class="feedback-item" v-for="(feedback, index) in arrayFeedback" v-if="show_all_feedbacks_1">
                                    <div class="feedback-item-avatar" v-if="feedback.is_teacher == 1">
                                        <img class="avatar" :src="feedback.avatar" alt="" v-if="feedback.avatar"/>
                                        <img class="avatar" src="/themes/web/assets/images/avatar-default-3.svg" alt="" v-else/>                                          
                                    </div>
                                    <div class="feedback-item-avatar" v-else>
                                        <img class="avatar" :src="feedback.avatar" alt="" v-if="feedback.avatar"/>
                                        <img class="avatar" src="/themes/web/assets/images/avatar-default-2.svg" alt="" v-else/>                                          
                                    </div>
                                    <div class="feedback-item-info">
                                        <div class="feedback-item-header">
                                            <div class="feedback-item-title">{{feedback.fullname || feedback.username}}</div>
                                            <div class="feedback-item-time">{{feedback.time | convertUnitToTime(' HH:mm - DD MMM, YYYY')}}</div>
                                        </div>
                                        <div>{{feedback.content}}</div>
                                    </div>
                                </div>
                                <div v-if="feedbacks[feedbacks.length-1] && feedbacks[feedbacks.length-1].is_teacher == 0">
                                    <div class="feedback-item" v-for="(feedback, index) in feedbacks" v-if="!show_all_feedbacks_1 && show_all_feedbacks || (show_all_feedbacks == false && index > feedbacks.length - 3)">
                                        <div class="feedback-item-avatar">
                                                <img class="avatar" :src="feedback.avatar" alt="" v-if="feedback.avatar"/>
                                                <img class="avatar" src="/themes/web/assets/images/avatar-default-3.svg" alt="" v-else-if="feedback.is_teacher == 1"/> 
                                                <img class="avatar" src="/themes/web/assets/images/avatar-default-2.svg" alt="" v-else/>                                          
                                        </div>
                                        <div class="feedback-item-info">
                                            <div class="feedback-item-header">
                                                <div class="feedback-item-title">{{feedback.fullname || feedback.username}}</div>
                                                <div class="feedback-item-time">{{feedback.time | convertUnitToTime(' HH:mm - DD MMM, YYYY')}}</div>
                                            </div>
                                            <div>{{feedback.content}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="feedback-item" v-for="(feedback, index) in feedbacks" v-if="!show_all_feedbacks_1 && show_all_feedbacks || (show_all_feedbacks == false && index == feedbacks.length - 1)">
                                        <div class="feedback-item-avatar">
                                                <img class="avatar" :src="feedback.avatar" alt="" v-if="feedback.avatar"/>
                                                <img class="avatar" src="/themes/web/assets/images/avatar-default-3.svg" alt="" v-else-if="feedback.is_teacher == 1"/> 
                                                <img class="avatar" src="/themes/web/assets/images/avatar-default-2.svg" alt="" v-else/>                                          
                                        </div>
                                        <div class="feedback-item-info">
                                            <div class="feedback-item-header">
                                                <div class="feedback-item-title">{{feedback.fullname || feedback.username}}</div>
                                                <div class="feedback-item-time">{{feedback.time | convertUnitToTime(' HH:mm - DD MMM, YYYY')}}</div>
                                            </div>
                                            <div>{{feedback.content}}</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- <template v-for="(feedback, index) in feedbacksParent" v-if="!show_all_feedbacks_1 && show_all_feedbacks || (show_all_feedbacks == false && index == feedbacksParent.length - 1)">
                                    <div class="feedback-item" v-bind:key="index">
                                    <div class="feedback-item-avatar">
                                            <img class="avatar" :src="feedback.avatar" alt="" v-if="feedback.avatar"/>
                                            <img class="avatar" src="/themes/web/assets/images/avatar-default-2.svg" alt="" v-else/>                                          
                                    </div>
                                    <div class="feedback-item-info">
                                        <div class="feedback-item-header">
                                            <div class="feedback-item-title">{{user_info.fullname}}</div>
                                            <div class="feedback-item-time">{{feedback.time | convertUnitToTime(' HH:mm - DD MMM, YYYY')}}</div>
                                        </div>
                                        <div>{{feedback.content}}</div>
                                    </div>
                                    </div>
                                </template> -->

                              </div>
                          </div>
                          <p class="d-flex align-items-center justify-content-center" v-if="feedbacks.length==0"  style="height: 100%; color:#1B1B1B; font-size: 16px; text-align: center;">{{$t('p_feedback_empty')}}</p>
                      </div>
                  </div>
                  <div  class="feedback-bottom" v-if="show_send_feedback_button && feedbacks.length!=0">
                      <div class="feedback-bottom-comment">
                          <input class="form-control" :placeholder="$t('write_a_comment')" v-model="comment" />
                          <button class="feedback-bottom-comment-submit" @click="confirmSendFeedback()">{{$t('send')}}</button>
                      </div>
                  </div>
              </div>
              
                <div class="modal modal-confirm fade modal-flex" id="confirmModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="confirmModal" aria-hidden="true">
                    <div class="modal-dialog" style="width: 475px; max-width: 475px;">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">{{$t('p_send_feedback')}}</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div>{{$t('p_feedback_warning_text')}}</div>
                            </div>
                            <div class="modal-footer" style="justify-content: center;">
                                <button type="button" class="btn btn-choose-image" style="padding: 6px 30px;" data-bs-dismiss="modal" aria-label="Close">{{$t('no')}}</button>
                                <button type="button" class="btn btn-main-sm" style="padding: 6px 30px;" @click = "sendFeedback">{{$t('yes')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

          </div>
      </div>

    </div>

  </main>
</template>

<script>
import axios from "axios";
import {pushQueries, soundClick} from '../../utils/utils'
import {mapGetters} from 'vuex'
import {getParentFeedbacks, sendFeedbackData} from "../../models/feedback";

export default {
  name: "ParentFeedback",
  title: 'Parents - Feaeback',

    data() {
        const user_info = this.$store.state.user_info;

        let child_account = localStorage.getItem('child_account');

        child_account = child_account?JSON.parse(child_account):null;

        if(child_account == null && user_info.childrens){
            child_account = user_info.childrens[0];
        }

        return {
            feedbacksParent: [],
            feedbacks: [],
            skills: [],
            feedbackParent:[],
            comment: '',
            child_account: child_account,
            show_all_feedbacks: false,
            show_send_feedback_button: true,
            arrayFeedback: [],
            show_all_feedbacks_1: false,
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },

  created() {
    this.$store.commit('setMenuActive', 'parent_feedback');

    this.fetch();
  },

  methods: {
    async fetch(page = 1) {
      const that = this;

      this.page = page;

      const params = {
        page: this.page,
      };

      //pushQueries(this.$router, '/inbox', params);

      await axios.all([
        getParentFeedbacks({
            user_id: this.child_account.id,
            parent_id: this.user_info.id
        }),
      ]).then(axios.spread((response) => {
        that.isLoading = false;

        //that.$store.commit("setLoading", false);

        if (response.data.code != 0) {
          return;
        }
        that.feedbacks = response.data.results.feedback || [];
        that.skills = response.data.results.skills || [];
        let feedback_Parent = response.data.results.feedback_Parent || []
        for(var i=0;i<feedback_Parent.length;i++){
            feedback_Parent[i].time =  new Date(feedback_Parent[i].createdAt).valueOf()  / 1000
        }
        that.feedbacksParent = feedback_Parent || [];
        
        this.arrayFeedback = that.feedbacks.concat(that.feedbacksParent).sort((a,b) => a.time - b.time);

        if(that.feedbacks.length > 0){
            const last_feedback = that.feedbacks[that.feedbacks.length - 1];

            if(last_feedback.is_teacher == 0){
                that.show_send_feedback_button = false;
            }
        }

        this.$nextTick(function() {
            var initNanoScroller = function() {
                if ($('.nano').length > 0) {
                    $(".nano").nanoScroller();
                }
            }

            initNanoScroller();
        })

      }));
    },

    confirmSendFeedback(){
        $('#confirmModal').modal('show');
    },

    updateShowAllFeedback(is_show){
        this.show_all_feedbacks = is_show;
        this.show_all_feedbacks_1 = is_show;
    },

    sendFeedback(){
        const that = this;

        sendFeedbackData({
            user_id: this.child_account.id,
            content: this.comment,
        }).then((response) => {
            that.$store.commit("setLoading", false);

            if (response.data.code != 0) {
                return;
            }
            that.feedbacks = response.data.results.feedback
            $('.feedback-bottom').hide();

            that.comment = "";

            $('#confirmModal').modal('hide');
        }).catch((response) => {
            that.$store.commit("setLoading", false);
        });        
    },

  }
}
</script>

<style scoped>

</style>
